import { Controller } from "@hotwired/stimulus"

const SUBDIVISION_FIELD_NAME = "practitioner_license[issuing_state]"

// A licence is issued by a US state or a Canadian province, so one subdivision
// select per country is rendered server-side and only the one matching the
// selected country is shown and submitted.
export default class extends Controller {
  static targets = ["countryInput", "subdivisionInput"]

  syncSubdivisionFields(event) {
    // Every app-select in the form bubbles this event, including license type.
    if (event.target !== this.countryInputTarget) return

    const country = this.countryInputTarget.value

    this.subdivisionInputTargets.forEach((input) => {
      const active = input.dataset.country === country

      input.closest(".app-select-container").classList.toggle("d-none", !active)
      input.name = active ? SUBDIVISION_FIELD_NAME : ""
    })
  }
}
